<template>
    <ChatProactiveOfferCard
        v-if="isVisible"
        test-id="proactive-feature-offer"
        offer-label="feature"
        :header="data.action_params.card_header"
        :subtext="data.action_params.card_subtext"
        :feedback="currentFeedback"
        :saved-for-later="isSaved"
        :busy="isBusy"
        :loading="isLoading"
        :error-message="errorMessage"
        :cta-label="ctaLabels[data.action_params.feature] ?? t('chat.agentTools.proactiveOffer.exploreFeature')"
        @dismiss="handleDismiss"
        @cta="handleOpenFeature"
        @rate="handleFeedback"
        @toggle-saved="handleToggleSaved" />
</template>

<script setup lang="ts">
import type { ParseActionsProactiveFeatureOfferAction } from "~vue/types/chat";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import ChatProactiveOfferCard from "./ChatProactiveOfferCard.vue";
import { useProactiveOfferAction } from "./useProactiveOfferAction";

const props = defineProps<{ data: ParseActionsProactiveFeatureOfferAction; lineIdx: number; messageId: number }>();
const { t } = useI18n();
const ctaLabels = computed<Record<ParseActionsProactiveFeatureOfferAction["action_params"]["feature"], string>>(() => ({
    calendar: t("chat.agentTools.proactiveOffer.connectCalendar"),
    my_work_insights: t("chat.agentTools.proactiveOffer.exploreMyWork"),
    perspectives: t("chat.agentTools.proactiveOffer.takeQuiz"),
    collaboration_profile: t("chat.agentTools.proactiveOffer.createProfile"),
    journeys: t("chat.agentTools.proactiveOffer.exploreJourneys"),
    microsoft_teams: t("chat.agentTools.proactiveOffer.openInTeams"),
    slack: t("chat.agentTools.proactiveOffer.openInSlack"),
}));
const { isVisible, isLoading, isBusy, currentFeedback, isSaved, errorMessage, handleDismiss, handleOpenFeature, handleFeedback, handleToggleSaved } = useProactiveOfferAction(
    () => props.data,
    props.messageId,
    props.lineIdx,
);
</script>
